export interface createCourses {
  id: number
  name: string
  line_url?: string
  line_qr_image_url?: string
  description?: string
}

export class Course {
  id: number
  name: string
  lineUrl: string
  lineQrImageUrl: string
  description: string

  constructor(args: createCourses) {
    this.id = args.id
    this.name = args.name
    this.lineUrl = args.line_url || ""
    this.lineQrImageUrl = args.line_qr_image_url || ""
    this.description = args.description || ""
  }
}
